<nb-card>
  <nb-card-header>
    <span>Reparaturaufträge</span>
    <div class="spacer"></div>
    <div class="tenant-filter">
      <form [formGroup]="form" class="filter-form">
        <div class="filter-control-group">
          <label class="label" for="title">Textfilter</label>
          <input type="text" nbInput id="title" formControlName="title" placeholder="Filter Text...">
        </div>
        <div class="filter-control-group">
          <label class="label" for="status">Status</label>
          <wr-repair-task-status-select id="status" formControlName="status"></wr-repair-task-status-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="contractorId">Firma</label>
          <wr-tenant-select [tenantType]="TenantTypeEnum.Contractor" id="contractorId" formControlName="contractorId"></wr-tenant-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="deadline">Fällig</label>
          <wr-date-picker id="deadline" formControlName="deadline"></wr-date-picker>
        </div>
      </form>
    </div>
  </nb-card-header>
  <wr-table [rows]="repairTasks()" [loading]="isLoading()" [rowLink]="getRepairTaskLink" [(sort)]="sort">
    <ng-template column let-repairTask [of]="repairTasks()" header="Name" sort="title">
      {{ repairTask.title }}
    </ng-template>
    <ng-template column let-repairTask [of]="repairTasks()" header="Prüfpunktzeile">
      <ng-container *ngIf="repairTask.inspectionEntry">
        {{repairTask.inspectionEntry.note || "-"}}
      </ng-container>
    </ng-template>
    <ng-template column let-repairTask [of]="repairTasks()" header="Frist" sort="deadline">
      <ng-container *ngIf="repairTask.deadline">
        {{ repairTask.deadline | date: 'dd.MM.yyyy' }}
      </ng-container>
    </ng-template>
    <ng-template column let-repairTask [of]="repairTasks()" header="Status" sort="status">
      <wr-repair-task-status-text [status]="repairTask.status"></wr-repair-task-status-text>
    </ng-template>
    <ng-template column let-repairTask [of]="repairTasks()" header="Firma">
      <div *ngIf="repairTask.contractor">
        {{ repairTask.contractor.name }}
      </div>
    </ng-template>
    <wr-table-pagination [totalRows]="count()"
                         [(pageSize)]="pageSize"
                         [(page)]="page"></wr-table-pagination>
  </wr-table>
</nb-card>
